window.gred = window.gred || {};
gred.init = function () {
  gred.showPopup();
  gred.hidePopup();
  gred.btnAddtocart();
  gred.quickView();
  gred.checkItemsInMiniCart();
  gred.removeItemsInMiniCart();
  gred.updatePricing();

  gred.hideDropdown();
  gred.hideFpu();
  gred.initAddToCart();

  gred.initWishlist();
  gred.initProductWishlist();
  gred.initRemoveWishlist();
  gred.initHeadRemoveWishlist();
};

// Set pixelRatio to 1 if the browser doesn't offer it up.
var pixelRatio = !!window.devicePixelRatio ? window.devicePixelRatio : 1;
$(window).on("load", function() {

  if (pixelRatio > 1) {
    $('img').each(function() {
      if($(this).data('2x') !== undefined) {
        var data2x = $(this).data('2x');  
        $(this).attr('src', $(this).attr('src').replace(data2x, data2x+"2x"));
      }    
    });
  }

});


jQuery(document).ready(function(){
  "use strict";

  /* Currency */
  $('.currency-Picker .dropdown-content a').on('click', function() { 
    $("select.currency-picker").val($(this).data('value')).change();
    $(this).closest('.dropdown-content').removeClass('active');     
  });

  $('.toggle-menu .caret').click(function(e){
    e.preventDefault(); 
    //$(this).closest('.toggle-content').find('.sub-menu').slideToggle("fast");
    $(this).parent().next().slideToggle("fast");
    return false;      
  })

  $('.l-fpu').click(function(e){
    e.preventDefault();     

    if($('.fpu-bg').hasClass()){    	
    } else{
      $('.fpu-bg').addClass('active');
    }

    var data = $(this).data('l');  
    $('.'+data).toggleClass("active");  
    return false;      
  })


  /* Mobile menu */  
  $('.mob-menu').click(function(e){
    e.preventDefault();
    $('.mob-content').slideToggle("fast");
  })

  $('.ofc-menu').click(function(e){
    e.preventDefault();
    $('.ofc').slideToggle("fast");
    $('html,body').animate({ scrollTop: 9999 }, 'slow');
  })


  var hH = $('.header--fixed').outerHeight();  
  $('.header-vsb').css( "height", hH );


  /* Currency */
  $('.currency-Picker .dropdown-content a').on('click', function() { 
    $("select.currency-picker").val($(this).data('value')).change();
    $(this).closest('.dropdown-content').removeClass('active');     
  });

  /* Memamenu */
  $(".width-full").each( function(){
    $(this).closest('.megamenu').addClass('full-width');

  });

  /* Search full */
  $('.cle-button').on('click', function (e) {
    e.preventDefault();
    $('.cle-content').toggleClass("active");    
  });

  $('.cle-close').on('click', function (e) {
    e.preventDefault();
    $(this).parent().toggleClass("active");    
  });


  /* more-views */
  $(".more-views .swiper-slide-active .thumb-link").addClass("active");


  /* Countdown */
  $('.countdown ul').each( function(){      
    var endDate = $(this).data( 'date' );      
    $(this).countdown({
      date: endDate,        
      render: function(data) {
        $(this.el).html(
          '<li><span>' + this.leadingZeros(data.days, 2) + '</span><br/>DAYS</li>'
          + '<li><span>' + this.leadingZeros(data.hours, 2) + '</span><br/>HOURS</li>'
          + '<li><span>' + this.leadingZeros(data.min, 2) + '</span><br/>MINUTES</li>'
          + '<li><span>' + this.leadingZeros(data.sec, 2) + '</span><br/>SECONDS</li>'
        );
      }
    });
  });


  $('.dropdown-toggle > a').click(function() {
    $('.mini-cart-default').removeClass('active');    
    if($(this).closest('.dropdown-toggle').find('.dropdown-content').hasClass('active')){
      $('.dropdown-content').removeClass('active');
    }else{
      $('.dropdown-content').removeClass('active');
      $(this).closest('.dropdown-toggle').find('.dropdown-content').addClass('active');  
    }     
    return false;              
  }); 


  /* Tabs */
  $(".e-tabs").each( function(){
    $(this).find('.tabs-title li:first-child').addClass('current');
    $(this).find('.tab-content').first().addClass('current');

    $(this).find('.tabs-title li').click(function(){
      var tab_id = $(this).attr('data-tab');

      var url = $(this).attr('data-url');
      $(this).closest('.e-tabs').find('.tab-viewall').attr('href',url);

      $(this).closest('.e-tabs').find('.tabs-title li').removeClass('current');
      $(this).closest('.e-tabs').find('.tab-content').removeClass('current');

      $(this).addClass('current');
      $(this).closest('.e-tabs').find("#"+tab_id).addClass('current');
    });    
  });


  /* Back to top */
  if ($('.back-to-top').length) {
    var scrollTrigger = 100, // px
        backToTop = function () {
          var scrollTop = $(window).scrollTop();
          if (scrollTop > scrollTrigger) {
            $('.back-to-top').addClass('show');
          } else {
            $('.back-to-top').removeClass('show');
          }
        };
    backToTop();
    $(window).on('scroll', function () {
      backToTop();
    });
    $('.back-to-top').on('click', function (e) {
      e.preventDefault();
      $('html,body').animate({
        scrollTop: 0
      }, 700);
    });
  }


})

$(document).on('click','.overlay, .close-popup', function() {   
  gred.hidePopup('.gred-popup'); 
  setTimeout(function(){
    $('.loading').removeClass('loaded-content');
  },500);
  return false;
})

jQuery('body').keydown(function(e) {
  if( e.which == 27) {
    gred.hidePopup('.gred-popup');    
    jQuery('body').unbind('keydown');
  }
});



/********************************************************
# MINICART
********************************************************/
jQuery(document).ready(function(){

  gred.quantity();
  $('.close-noitice').click(function(e){
    e.preventDefault(); 
    $(this).parent().animate({right: '-300px'}, 500);  
  })


});


/********************************************************
# DROPDOWN
********************************************************/
gred.hideDropdown = function () {  
  $(document).on('click touchstart', function(e) {
    var dropdown = $(".dropdown-content");
    if (!dropdown.is(e.target) && dropdown.has(e.target).length === 0) {
      dropdown.removeClass('active');      
    }
  });
}

gred.hideFpu = function () {  
  $(document).on('click touchstart', function(e) {
    var dropdown = $(".fpu");
    if (!dropdown.is(e.target) && dropdown.has(e.target).length === 0) {
      dropdown.removeClass('active');      
    }
  });

  $('.l-fpu-close').click(function() {
    $('.fpu').removeClass('active');
    return false;              
  }); 

}



/********************************************************
# toggle-menu
********************************************************/
gred.toggleMenu = function () {  
  $('.toggle-menu .caret').click(function() {
    $(this).closest('.toggle-content').find('.sub-menu').slideToggle("fast");
    return false;              
  }); 
}


/********************************************************
# QUANTITY
********************************************************/
gred.quantity = function () {  
  $('.qtyplus').click(function(e){  
    e.preventDefault();   
    fieldName = $(this).attr('data-field'); 
    var currentVal = parseInt($('input[data-field='+fieldName+']').val());
    if (!isNaN(currentVal)) { 
      $('input[data-field='+fieldName+']').val(currentVal + 1);
    } else {
      $('input[data-field='+fieldName+']').val(0);
    }
    gred.updatePricing();
  })

  $(".qtyminus").click(function(e) {
    e.preventDefault(); 
    fieldName = $(this).attr('data-field');
    var currentVal = parseInt($('input[data-field='+fieldName+']').val());
    if (!isNaN(currentVal) && currentVal > 1) {          
      $('input[data-field='+fieldName+']').val(currentVal - 1);
    } else {
      $('input[data-field='+fieldName+']').val(1);
    }
    gred.updatePricing();
  })

  $('#Quantity').on('change' , function () { 
    gred.updatePricing();
  })
}


/********************************************************
# SHOW NOITICE
********************************************************/
gred.showNoitice = function (selector) {   
  $(selector).animate({right: '0'}, 500);
  setTimeout(function() {
    $(selector).animate({right: '-300px'}, 500);
  }, 3500);
};


/********************************************************
# SHOW LOADING
********************************************************/
gred.showLoading = function (selector) {    
  var loading = $('.loader').html();
  $(selector).addClass("loading").append(loading);  
}

/********************************************************
# HIDE LOADING
********************************************************/
gred.hideLoading = function (selector) {  
  $(selector).removeClass("loading"); 
  $(selector + ' .loading-icon').remove();
}


/********************************************************
# SHOW POPUP
********************************************************/
gred.showPopup = function (selector) {
  $(selector).addClass('active');
};

/********************************************************
# HIDE POPUP
********************************************************/
gred.hidePopup = function (selector) {
  $(selector).removeClass('active');
}

/********************************************************
# CONVERTTOSLUG
********************************************************/
gred.convertToSlug = function (text) {
  return text.toLowerCase().replace(/[^a-z0-9 -]/g, '').replace(/\s+/g, '-').replace(/-+/g, '-');
}


/********************************************************
# UPDATEPRICING
********************************************************/
gred.updatePricing = function(){

  var regex = /([0-9]+[.|,][0-9]+[.|,][0-9]+)/g;
  var unitPriceTextMatch = jQuery('.product-single .product-single-prices .money').text().match(regex);

  if (!unitPriceTextMatch) {
    regex = /([0-9]+[.|,][0-9]+)/g;
    unitPriceTextMatch = jQuery('.product-single .product-single-prices .money').text().match(regex);     
  }

  if (unitPriceTextMatch) {
    var unitPriceText = unitPriceTextMatch[0];     
    var unitPrice = unitPriceText.replace(/[.|,]/g,'');
    var quantity = parseInt(jQuery('#Quantity').val());
    var totalPrice = unitPrice * quantity;

    var totalPriceText = Shopify.formatMoney(totalPrice, window.money_format);
    regex = /([0-9]+[.|,][0-9]+[.|,][0-9]+)/g;     
    if (!totalPriceText.match(regex)) {
      regex = /([0-9]+[.|,][0-9]+)/g;
    } 
    totalPriceText = totalPriceText.match(regex)[0];

    var regInput = new RegExp(unitPriceText, "g"); 
    var totalPriceHtml = jQuery('.product-single .money').html().replace(regInput ,totalPriceText);

    $('.total-price .money').html(totalPriceHtml); 

  }
}


/********************************************************
# QUICKVIEW - ADDTOCART
********************************************************/
gred.quickviewAddToCart = function () {
  if ($('.quickview-product .btn-addToCart').length > 0) {
    $('.quickview-product .btn-addToCart').click(function() {
      var variant_id = $('.quickview-product select[name=id]').val();
      if (!variant_id) {
        variant_id = $('.quickview-product input[name=id]').val();
      }
      var quantity = $('.quickview-product input[name=quantity]').val();
      if (!quantity) {
        quantity = 1;
      }

      var title = $('.quickview-product .product-name a').html();
      var image = $('.quickview-product .featured-image img').attr('src');

      gred.doAjaxAddToCart(variant_id, quantity, title, image);               
    });
  }
}


/********************************************************
# PRODUCT DETAIL - ADDTOCART
********************************************************/
gred.btnAddtocart = function () {
  $(window.btn_addToCart).click(function(event) { 
    event.preventDefault();
    if ($(this).attr('disabled') != 'disabled') {
      var variant_id = $(window.product_detail_form +' select[name=id]').val();
      if (!variant_id) {
        variant_id = $(window.product_detail_form +' input[name=id]').val();
      }
      var quantity = $(window.product_detail_form +' input[name=quantity]').val();
      if (!quantity) {
        quantity = 1;
      }
      var title = $(window.product_detail_name).html();
      var image = $(window.product_detail_mainImg).attr('src');
      gred.doAjaxAddToCart(variant_id, quantity, title, image);
    }
    return false;
  });
}

gred.switchImage = function (src, imgObject, el) {
  // Make sure element is a jquery object
  var $el = $(el);
  $el.attr('src', src);
};


gred.productPage = function (options) {
  var moneyFormat = options.money_format,
      variant = options.variant,
      selector = options.selector,
      translations = options.translations;

  // Selectors
  var $addToCart = $('#btnAddtocart'), 
      $productImage = $('.product-single-photos img'),
      $productPrice = $('#ProductPrice'),
      $totalPrice = $('.total-price'), 
      $comparePrice = $('#ComparePrice'),
      $quantityElements = $('.product-single-quantity'),
      $addToCartText = $('#btnAddtocart');

  if (variant) {

    // Update variant image, if one is set
    if (variant.featured_image) {
      var newImg = variant.featured_image,
          el = $productImage[0];
      Shopify.Image.switchImage(newImg, el, gred.switchImage);
      var variantImage =  variant.featured_image.src.split('?')[0].replace(/http(s)?:/,'');      
      $(".cloud-zoom").attr("href", variantImage)
      $(".mousetrap").remove();
      $(".cloud-zoom").CloudZoom();
    }

    // Select a valid variant if available
    if (variant.available) {
      // Available, enable the submit button, change text, show quantity elements
      $addToCart.removeClass('disabled').prop('disabled', false);
      $addToCartText.html(translations.add_to_cart);
      $quantityElements.removeClass('soldout');
    } else {
      // Sold out, disable the submit button, change text, hide quantity elements
      $addToCart.addClass('disabled').prop('disabled', true);
      $addToCartText.html(translations.sold_out);
      $quantityElements.addClass('soldout'); 
    }

    // Regardless of stock, update the product price
    $productPrice.html( Shopify.formatMoney(variant.price, moneyFormat) );

    var variant_price = $('#Quantity').val() * variant.price;
    $totalPrice.html( Shopify.formatMoney(variant_price, moneyFormat) ); 

    // Also update and show the product's compare price if necessary
    if (variant.compare_at_price > variant.price) {
      $comparePrice.html(Shopify.formatMoney(variant.compare_at_price, moneyFormat)).removeClass('soldout');
    } else {
      $comparePrice.addClass('soldout');
    }

  } else {
    // The variant doesn't exist, disable submit button.
    // This may be an error or notice that a specific variant is not available.
    // To only show available variants, implement linked product options:
    //   - http://docs.shopify.com/manual/configuration/store-customization/advanced-navigation/linked-product-options
    $addToCart.addClass('disabled').prop('disabled', true);
    $addToCartText.html(translations.unavailable);
    $quantityElements.addClass('soldout');
  };


}


/********************************************************
# ADD TO CART
********************************************************/
gred.initAddToCart = function () {
  $('.product-item .btn-addToCart').click(function(event) {    
    event.preventDefault();
    if ($(this).attr('disabled') != 'disabled') {      
      var productItem = $(this).closest('.product-item');
      var productId = $(this).closest('.product-item').attr('data-id');      
      productId = productId.match(/\d+/g);

      var variant_id = $('#AddToCartForm-' + productId + ' select[name=id]').val();
      if (!variant_id) {
        variant_id = $('#AddToCartForm-' + productId + ' input[name=id]').val();
      }

      var quantity = $('#AddToCartForm-' + productId + ' input[name=quantity]').val();
      if (!quantity) {
        quantity = 1;
      }

      var title = $(productItem).find('.product-item-name').html();
      var image = $(productItem).find('.product-item-photo img').attr('src');

      gred.doAjaxAddToCart(variant_id, quantity, title, image); 
    }
    return false;
  });
}

gred.doAjaxAddToCart = function (variant_id, quantity, title, image) { 
  $.ajax({
    type: "post",
    url: "/cart/add.js",
    data: 'quantity=' + quantity + '&id=' + variant_id, 
    dataType: 'json', 
    beforeSend: function() {    
      if(window.theme_load == "icon"){
        gred.showLoading('.btn-addToCart');
      } else{
        gred.showPopup('.loading'); 
      }
    },
    success: function(msg) {  

      gred.hidePopup('.quickview-product');       
      if(window.theme_load == "icon"){
        gred.hideLoading('.btn-addToCart');
      } else{
        $('.loading').addClass('loaded-content');         
      }

      switch (window.addcart_susscess) {
        case ('popup'):     
          $('.fpu-addtocart').find('.product-name').html(title);         
          $('.fpu-addtocart').find('.product-image img').attr('src', image);
          gred.showPopup('.fpu-addtocart');
          break;
        case ('text'):
          gred.hidePopup('.loading'); 
          gred.hideLoading('.btn-addToCart');

          break;
        case ('noitice'):          
          gred.hidePopup('.loading'); 
          gred.hideLoading('.btn-addToCart');
          $('.product-noitice.susscess').find('.product-name').html(title);
          $('.product-noitice.susscess').find('.product-image img').attr('src', image);
          gred.showNoitice('.product-noitice.susscess');

          break;
        default: gred.showPopup('.fpu-addtocart');

      }

      gred.updateMiniCart();

    },
    error: function(xhr, text) {
      gred.hidePopup('.loading'); 
      $('.error-message').text($.parseJSON(xhr.responseText).description);
      gred.showPopup('.error-popup');

    }
  });
}


/********************************************************
# UPDATE MINICART
********************************************************/
gred.updateMiniCart = function() {
  Shopify.getCart(function(cart) {        
    gred.doUpdateMiniCart(cart);
  });
}

gred.updateMiniCart2 = function() {
  Shopify.getCart(function(cart) {        
    gred.doUpdateMiniCart2(cart);
  });
}

/* DO UPDATE MINICART */ 
gred.doUpdateMiniCart = function(cart) {   
  var template = '<li class="item clearfix" id="cart-item-{id}"><a href="{url}" title="{title}" class="product-image"><img src="{img}" alt="{title}"></a><div class="product-details"><a class="product-name" href="{url}">{title}</a><span class="money">{price}</span><span class="qty">'+window.quantity+'{quantity}</span> <a href="javascript:void(0)" title="Remove This Item" class="btn-remove"></a></div></li>';

  $(window.cart_count).text(cart.item_count); 
  $(window.cart_total).html(Shopify.formatMoney(cart.total_price, window.money_format)); 
  $('.miniCart-list').html('');

  if (cart.item_count > 0) {

    $('.miniCart-content .summary').removeClass('hidden');
    $('.miniCart-content .miniCart-list').removeClass('hidden');
    $('.mnl-products .scroll-wrapper').removeClass('hidden');
    $('.miniCart-content .scroll-content').removeClass('hidden');

    for (var i = 0; i < cart.items.length; i++) {      
      var item = template;
      item = item.replace(/\{id\}/g, cart.items[i].id);
      item = item.replace(/\{url\}/g, cart.items[i].url);
      item = item.replace(/\{title\}/g, cart.items[i].product_title);
      item = item.replace(/\{quantity\}/g, cart.items[i].quantity);
      item = item.replace(/\{product_id\}/g, cart.items[i].product_id);
      item = item.replace(/\{img\}/g, Shopify.resizeImage(cart.items[i].image, 'compact'));
      item = item.replace(/\{price\}/g, Shopify.formatMoney(cart.items[i].price, window.money_format));
      $('.miniCart-list').append(item);
    }
    gred.removeItemsInMiniCart();
    gred.initReview(); 
    gred.ConvertCurrency();
    gred.checkItemsInMiniCart();
  } else{
    $('.miniCart-content .summary').addClass('hidden');
    $('.miniCart-content .miniCart-list').addClass('hidden');
    $('.mnl-products .scroll-wrapper').addClass('hidden');
  }
}

/* DO UPDATE MINICART2 */ 
gred.doUpdateMiniCart2 = function(cart) {     
  $(window.cart_count).text(cart.item_count); 
  $(window.cart_total).html(Shopify.formatMoney(cart.total_price, window.money_format)); 
  if (cart.item_count > 0) {    
    $('.miniCart-content .summary').removeClass('hidden');
    $('.miniCart-content .miniCart-list').removeClass('hidden');
    $('.mnl-products .scroll-wrapper').removeClass('hidden');

    gred.removeItemsInMiniCart();
    gred.initReview(); 
    gred.ConvertCurrency();
    gred.checkItemsInMiniCart(); 
  } else{
    $('.miniCart-content .summary').addClass('hidden');
    $('.miniCart-content .miniCart-list').addClass('hidden');
    $('.mnl-products .scroll-wrapper').addClass('hidden');

  }
}


/********************************************************
# QUiCKVIEW
********************************************************/
gred.quickView = function() {
  $('.btn-quickview').click(function() {
    gred.showPopup('.loading');
    var id = $(this).attr('id');
    var rating = (($(this).closest('.product-item-info').find('[id*="spr_badge"]').attr('data-rating')) * 20)+"%";
    var ratingCaption = $(this).closest('.product-item-info').find('.spr-badge-caption').text();
    var available = $(this).closest('.product-item-info').attr('data-available');
    var color_swatch = false /**/;

    Shopify.getProduct(id, function(product) {
      var template = $('#quickview-template').html();
      $('.quickview-product').html(template);
      var quickview = $('.quickview-product');
      quickview.find('.product-name a').html(product.title).attr('href', product.url).attr('title', product.title);

      if(product.available){
        quickview.find('.instock').addClass('active');
      } else{
        quickview.find('.outofstock').addClass('active');
      }

      if (quickview.find('.spr-badge').length > 0) {
        quickview.find('.spr-badge .spr-active').css({"width": rating});
        quickview.find('.spr-badge-caption').text(ratingCaption);
      }

      if (quickview.find('.vendor').length > 0) {
        quickview.find('.vendor span').text(product.vendor);
      }

      quickview.find('.price').html(Shopify.formatMoney(product.price, window.money_format));

      if (quickview.find('.des').length > 0) { 
        var description = product.description;        
        quickview.find('.des').html(description);
      } else { 
        quickview.find('.des').remove();
      }


      quickview.find('.products-item').attr('id', 'product-' + product.id);
      quickview.find('.variants').attr('id', 'product-actions-' + product.id);
      quickview.find('.variants select').attr('id', 'product-select-' + product.id);

      if (product.compare_at_price > product.price) {
        quickview.find('.compare-price').html(Shopify.formatMoney(product.compare_at_price_max, window.money_format)).show();
        quickview.find('.price').addClass('on-sale');
      } else {
        quickview.find('.compare-price').html('');
        quickview.find('.price').removeClass('on-sale');
      }

      //out of stock
      if (!product.available) {
        quickview.find("select, input, .total-price, .dec, .inc, .variants label, .product-options, .product-single-quantity").remove();
        quickview.find(".btn-addToCart").text('unavailable').addClass('disabled').attr("disabled", "disabled");
      } else {
        quickview.find('.total-price span').html(Shopify.formatMoney(product.price, window.money_format));

        if(color_swatch) {
          gred.createQuickViewVariantsSwatch(product, quickview);              
        }else {            
          gred.createQuickViewVariants(product, quickview);
        }
      }

      gred.quantity();
      gred.ConvertCurrency();
      gred.quickviewAddToCart();    
      gred.hideFpu();
      gred.loadQuickViewSlider(product, quickview);
      gred.showPopup('.quickview-product');      
      $('.quickview-product .scrollbar-outer').scrollbar();


    });
    return false; 
  })
};


/* createQuickViewVariantsSwatch */
gred.createQuickViewVariantsSwatch = function(product, quickviewTemplate) {

  if (product.variants.length < 2) { 
    quickviewTemplate.find('form.variants .product-options').addClass('hidden');
  }
  if (product.variants.length > 1) { 
    for (var i = 0; i < product.variants.length; i++) {
      var variant = product.variants[i];
      var option = '<option value="' + variant.id + '">' + variant.title + '</option>';
      quickviewTemplate.find('form.variants .product-options > select').append(option);
    }

    new Shopify.OptionSelectors("product-select-" + product.id, {
      product: product,
      onVariantSelected: selectCallbackQuickview
    });

    var filePath = window.file_url.substring(0, window.file_url.lastIndexOf('?'));
    var assetUrl = window.asset_url.substring(0, window.asset_url.lastIndexOf('?'));
    var options = "";

    for (var i = 0; i < product.options.length; i++) {
      options += '<div class="swatch clearfix" data-option-index="' + i + '">';
      options += '<div class="header">' + product.options[i].name + '</div>';
      var is_color = false;
      if (/Color|Colour/i.test(product.options[i].name)) {
        is_color = true;
      }
      var optionValues = new Array();
      for (var j = 0; j < product.variants.length; j++) {
        var variant = product.variants[j];
        var value = variant.options[i];
        var valueHandle = gred.convertToSlug(value);
        var forText = 'swatch-' + i + '-' + valueHandle;
        if (optionValues.indexOf(value) < 0) {
          //not yet inserted
          options += '<div data-value="' + value + '" class="swatch-element ' + (is_color ? "color" : "") + valueHandle + (variant.available ? ' available ' : ' soldout ') + '">';

          if (is_color) {
            options += '<div class="tooltip">' + value + '</div>';
          }
          options += '<input id="' + forText + '" type="radio" name="option-' + i + '" value="' + value + '" ' + (j == 0 ? ' checked ' : '') + (variant.available ? '' : ' disabled') + ' />';

          if (is_color) {
            options += '<label for="' + forText + '" style="background-color: ' + valueHandle + '; background-image: url(' + filePath + valueHandle + '.png)"></label>';
          } else {
            options += '<label for="' + forText + '">' + value + '</label>';
          }
          options += '</div>';
          if (variant.available) {
            $('.quickview-product .swatch[data-option-index="' + i + '"] .' + valueHandle).removeClass('soldout').addClass('available').find(':radio').removeAttr('disabled');
          }
          optionValues.push(value);
        }
      }
      options += '</div>';
    }
    quickviewTemplate.find('form.variants .product-options > select').after(options);
    quickviewTemplate.find('.swatch :radio').change(function() {
      var optionIndex = $(this).closest('.swatch').attr('data-option-index');
      var optionValue = $(this).val();
      $(this)
      .closest('form')
      .find('.single-option-selector')
      .eq(optionIndex)
      .val(optionValue)
      .trigger('change');
    });

    if (product.available && product.options.size > 1) {
      Shopify.optionsMap = {};
      Shopify.linkOptionSelectors(product);
    }

  } else {
    quickviewTemplate.find('form.variants .product-options > select').remove();
    var variant_field = '<input type="hidden" name="id" value="' + product.variants[0].id + '">';
    quickviewTemplate.find('form.variants .product-options').append(variant_field);
  }
};


/* createQuickViewVariants */
gred.createQuickViewVariants = function(product, quickviewTemplate) {  

  if (product.variants.length < 1) { 
    quickviewTemplate.find('form.variants .product-options').addClass('hidden');
  }
  if (product.variants.length > 0) {
    for (var i = 0; i < product.variants.length; i++) {
      var variant = product.variants[i];
      var option = '<option value="' + variant.id + '">' + variant.title + '</option>';
      quickviewTemplate.find('form.variants .product-options > select').append(option);
    }

    new Shopify.OptionSelectors("product-select-" + product.id, {
      product: product,
      onVariantSelected: selectCallbackQuickview
    });

    quickviewTemplate.find('form.variants .selector-wrapper').each(function(i, v) {
      $(this).prepend('<div class="header">' + product.options[i].name + '</div>');      
    });

    quickviewTemplate.find('form.variants .selector-wrapper label').each(function(i, v) {
      $(this).remove();
    });

  } else {
    quickviewTemplate.find('form.variants .product-options > select').remove();
    var variant_field = '<input type="hidden" name="id" value="' + product.variants[0].id + '">';
    quickviewTemplate.find('form.variants .product-options').append(variant_field);
  }   
}


/* QuickView VIEWMORE Slider */
gred.loadQuickViewSlider = function(product, quickviewTemplate) {
  var featuredImage = Shopify.resizeImage(product.featured_image, '1024x1024');
  quickviewTemplate.find('.featured-image').append('<a title="'+ product.title +'" class="product-photo" href="' + product.url + '"><img src="' + featuredImage + '" alt="' + product.title + '"/><span class="loading" style="height: 30px; line-height: 30px; padding: 0 40px; color: #fff; background: #000; opacity: 0.4; bottom: 100px; left: 50%; z-index: 999; position: absolute; display: none;">'+ window.loading_url +'</span></a>');
  if (product.images.length > 1) { 
    var quickViewCarousel = quickviewTemplate.find('.more-views .swiper-wrapper');

    for (i in product.images) {
      var original = Shopify.resizeImage(product.images[i], 'original');
      var compact = Shopify.resizeImage(product.images[i], 'compact');
      var item = '<div class="swiper-slide"><a href="javascript:void(0)" data-image="' + original + '"><img src="' + compact + '"  /></a></div>';
      quickViewCarousel.append(item); 
    }

    quickViewCarousel.find('a').click(function() {
      var featureImage = quickviewTemplate.find('.featured-image img');
      var moreviewLoad = quickviewTemplate.find('.featured-image .loading');
      if (featureImage.attr('src') != $(this).attr('data-image')) {
        featureImage.attr('src', $(this).attr('data-image'));
        /* moreviewLoad.show(); */
        featureImage.load(function(e) {
          moreviewLoad.hide();
          $(this).unbind('load');
          moreviewLoad.hide();
        });
      }
    });

    var swiper = quickviewTemplate.find('.more-views');
    var mySwiper = new Swiper (swiper, {
      direction: 'vertical',
      slidesPerView: 4,
      spaceBetween: 10,
      paginationClickable: true,
      grabCursor: true 
    })

    } else {
      quickviewTemplate.find('.more-views').remove();
    }

}

/* reConvertCurrency */
gred.reConvertCurrency = function() {       
  return window.show_multiple_currencies && Currency.currentCurrency != shopCurrency;  
};

/* REMOVE ITEM CART */
gred.removeItemsInMiniCart = function() { 
  $('.btn-remove').click(function(event) {     
    event.preventDefault();       
    var productId = $(this).parents('.item').attr('id');
    var item = $(this).closest('.item');
    $(this).closest('.item').fadeOut("slow");

    productId = productId.match(/\d+/g);
    Shopify.removeItem(productId, function(cart) {
      gred.updateMiniCart2(cart);
    }); 

  }); 
};


/* CHECK ITEM MINI CART */
gred.checkItemsInMiniCart = function() {  
  if($('.miniCart-list').children().length > 0) {
    $('.miniCart-content').removeClass('empty-cart');           
  } else{
    $('.miniCart-content').addClass('empty-cart'); 
  }
}

/********************************************************
# WISHLIST
********************************************************/
gred.initRemoveCWishlist = function() {
  var count = $('.wl-link .count').html();
  count = count - 1;
  $('.wl-link .count').html(count);
  if(count == 0){
    $('.drc-wishlist .no-item').removeClass('empty');
    $('.drc-wishlist .summary').addClass('empty');
  }

}

gred.initAddCWishlist = function() {
  var count = $('.wl-link .count').html();
  count = (count*100 + 1*100) / 100;   
  $('.wl-link .count').html(count);

  if(count > 0){
    $('.drc-wishlist .no-item').addClass('empty');
    $('.drc-wishlist .summary').removeClass('empty');
  }
}

gred.initWishlist = function() {
  $('.product-item-info .add-to-wishlist').click(function(e) {
    e.preventDefault();
    var form = $(this).closest('form');  
    var productItem = $(this).closest('.product-item-info');

    $.ajax({
      type: 'POST',
      url: '/contact',
      data: form.serialize(),
      beforeSend: function() {
        gred.showPopup('.loading');
      },
      success: function(data) { 
        form.html('');
        var title = $(productItem).find('.product-item-name').html();
        var image = $(productItem).find('.product-item-photo img').attr('src');    

        var tag_id = 'xx'+$(productItem).find('.product-ID').html();
        var url = $(productItem).find('.product-URL').html();
        var price = $(productItem).find('.price-box .money').html();
        var status = $(productItem).find('.product-STT').html();  

        $('.wishlist-popup').find('.product-name').html(title);
        $('.wishlist-popup').find('.product-image img').attr('src', image);    
        gred.showPopup('.wishlist-popup');
        gred.initUpdateWishlist(url, image, title, price, status, tag_id);
        gred.initAddCWishlist();

      },
      error: function(xhr, text) { 
        form.html('');   
        $('.error-message').text($.parseJSON(xhr.responseText).description);
        gred.showPopup('.error-popup');
      }
    });
  });

}



gred.initProductWishlist = function() {
  $('.product-single .add-to-wishlist').click(function(e) {
    e.preventDefault();
    var form = $(this).closest('form');  

    $.ajax({
      type: 'POST',
      url: '/contact',
      data: form.serialize(),
      beforeSend: function() {
        gred.showPopup('.loading'); 
      },
      success: function(data) {       

        var title = $('.product-info h1').html();
        var image = $('.product-single-photos img').attr('src');
        var tag_id = 'xx'+$('.product-ID').html();
        var url = $('.product-URL').html();
        var price = $('.product-single-prices .money').html();
        var status = $('.product-STT').html();    

        $('.wishlist-popup').find('.product-name').html(title);
        $('.wishlist-popup').find('.product-image img').attr('src', image);
        gred.showPopup('.wishlist-popup');
        gred.initUpdateWishlist(url, image, title, price, status, tag_id);
        gred.initAddCWishlist();
      },
      error: function(xhr, text) {
        gred.hidePopup('.loading');    
        $('.error-message').text($.parseJSON(xhr.responseText).description);
        gred.showPopup('.error-popup');  
      }
    });
  }); 
}

/* Remove Wishlist */ 
gred.initRemoveWishlist = function() {
  $('.btn-remove-wishlist').click(function(e) {
    e.preventDefault();
    var row = $(this).parents('tr');
    var tagID = row.find('.tag-id').val();
    var form = jQuery('#remove-wishlist-form');


    form.find("input[name='contact[tags]']").val('x' + tagID);
    $.ajax({
      type: 'POST',
      url: '/contact',
      data: form.serialize(),
      beforeSend: function() {
        gred.showPopup('.loading'); 

      },
      success: function(data) {        
        row.fadeOut(100);        
        gred.initRemoveCWishlist();
        // gred.hidePopup('.loading');  
      },
      error: function(xhr, text) {
        $('.error-message').text($.parseJSON(xhr.responseText).description);
        gred.showPopup('.error-popup');
      }
    });
  });
}

/* Header Remove Wishlist */ 
gred.initHeadRemoveWishlist = function() {
  $('.btn-removeWishlist').click(function(e) {
    e.preventDefault();
    var row = $(this).closest('.item');
    var tagID = row.find('.tag-id').val();
    var form = jQuery('#remove-wishlist-form');

    form.find("input[name='contact[tags]']").val('x' + tagID);
    $.ajax({
      type: 'POST',
      url: '/contact',
      data: form.serialize(),
      beforeSend: function() {
        //gred.showPopup('.loading'); 
      },
      success: function(data) {
        row.fadeOut(500);
        gred.initRemoveCWishlist();
        // gred.hidePopup('.loading');  
      },
      error: function(xhr, text) {
        $('.error-message').text($.parseJSON(xhr.responseText).description);
        gred.showPopup('.error-popup');
      }
    });
  });
}

gred.initUpdateWishlist = function(url, image, title, price, status, tag_id) {
  var template = '<li class="item"><a href="{url}" class="product-image" title=""><img src="{img}" alt="{title}"></a><div class="product-details"><a href="{url}" class="product-name">{title}</a><span class="money">{price}</span><span class="product-stock-status"><span class="wishlist-{status}">{status}</span></span><input class="tag-id" type="hidden" value="{tag_id}" /></div></li>';
  var item = template;
  item = item.replace(/\{url\}/g, url);
  item = item.replace(/\{img\}/g, image);
  item = item.replace(/\{title\}/g, title);
  item = item.replace(/\{price\}/g, price);
  item = item.replace(/\{status\}/g, status);  
  item = item.replace(/\{tag_id\}/g, tag_id);  
  $('.wishlist.mnl-content').append(item);
}

/********************************************************
# CUSTOMER
********************************************************/



/********************************************************
# REVIEW
********************************************************/
gred.initReview = function() {
  if ($(".spr-badge").length > 0) {
    if(window.review ){
      return window.SPR.registerCallbacks(), window.SPR.initRatingHandler(), window.SPR.initDomEls(), window.SPR.loadProducts(), window.SPR.loadBadges();
    };
  };
}

/********************************************************
# CURRENCY
********************************************************/
gred.ConvertCurrency = function() {
  if (gred.reConvertCurrency() && window.show_multiple_currencies ) {
    Currency.convertAll(window.shop_currency, jQuery('.currency-picker').val(), 'span.money', 'money_with_currency_format' ); 
                        }
                        }

                        $(gred.init)


